import {
  AfterViewInit,
  Component,
  ElementRef,
  Injector,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewEncapsulation,
} from "@angular/core";
import { Router } from "@angular/router";
import { LanguageType } from "@shared/models/common/language-type.enum";
import { AODA } from "../../../core/utilities/aoda";
import { BaseComponent } from "../base.component";

@Component({
  selector: "app-top-nav",
  templateUrl: "./top-nav.component.html",
  styleUrls: ["./top-nav.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class TopNavComponent
  extends BaseComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  constructor(
    private injector: Injector,
    public router: Router,
    private el: ElementRef,
    private renderer: Renderer2
  ) {
    super(injector);
  }

  ngOnInit() {
    super.ngOnInit();
    this.loadOntarioA11y();
    this.loadOntarioHeader();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  ngAfterViewInit() {
    AODA.applyAllFixes(
      this.el,
      this.renderer,
      this.languageService.languageType
    );
  }

  navigateToHome() {
    this.router.navigate(["/"]);
  }

  get languageType() {
    return LanguageType;
  }

  get oppositeLanguage() {
    const preference = this.cacheService.preference;
    return preference.languageType === LanguageType.English
      ? LanguageType.French
      : LanguageType.English;
  }

  switchLanguage() {
    const languageType =
      this.cacheService.preference.languageType === LanguageType.English
        ? LanguageType.French
        : LanguageType.English;
    const preference = this.cacheService.preference;
    preference.languageType = languageType;
    this.cacheService.preference = preference;
    this.languageService.languageType = languageType;
  }

}
